var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2503 0L0 4.464V29.024L20.2503 33.49V29.024H33.9775H36V4.464H33.9775H20.2503V0ZM2.01532 27.4192V6.06816L18.2337 2.49316V30.9972L2.01532 27.4192ZM20.2501 6.4707H33.9774V27.0167H20.2501V24.3327H24.7496V22.3247H20.2501V19.8967H24.7496V17.8897H20.2501V15.4607H24.7496V13.4537H20.2501V11.0247H24.7496V9.0177H20.2501V6.4707Z",
    fill: "#d5121e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.886 11.0256H31.6163V9.01855H26.886V11.0256Z",
    fill: "#d5121e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.886 15.4611H31.6163V13.4541H26.886V15.4611Z",
    fill: "#d5121e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.886 19.8976H31.6163V17.8906H26.886V19.8976Z",
    fill: "#d5121e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.886 24.3342H31.6163V22.3262H26.886V24.3342Z",
    fill: "#d5121e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26356 21.4779L6.85476 22.7069L10.5027 18.0519L14.6092 22.7079L16.1258 21.3919L11.7634 16.4449L16.1117 10.8969L14.5205 9.66895L10.411 14.9119L6.76809 10.7809L5.25146 12.0989L9.15036 16.5189L5.26356 21.4779Z",
    fill: "#d5121e"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excel.466ee06bec8fca666277068e763f1c7d.svg";